export default "__VITE_ASSET__B2jwhSvu__"